import { useMemo } from 'react';
import { PortalUserAccess } from 'models';
import { useAppSelector } from './redux';
import { authSelector } from 'store';
import {
  hasAdminAccess,
  hasAssignSoftwareAccess,
  hasAzureAccess,
  hasDeviceAccess,
  hasDeviceUpdateAccess,
  hasSetDesiredAccess,
  hasHusqiotBusAccess,
  hasLwm2mLogsAccess,
  hasRolloutCreateAccess,
  hasRolloutReadAccess,
  hasRolloutStartAccess,
  hasSoftwareReadAccess,
  hasSoftwareUploadAccess,
} from 'utils/roles';

export const useAccess = (): PortalUserAccess => {
  const { session } = useAppSelector(authSelector);

  return useMemo(() => {
    const { portalUser } = session;
    if (!portalUser) {
      return {
        azureAccess: false,
        readDeviceAccess: false,
        updateDeviceAccess: false,
        setDesiredAccess: false,
        softwareAccess: false,
        softwareUploadAccess: false,
        rolloutAccess: false,
        createRolloutAccess: false,
        startRolloutAccess: false,
        assignSoftwareAccess: false,
        readLwm2mLogsAccess: false,
        husqiotBusAccess: false,
        adminAccess: false,
        groups: [],
      };
    }
    return {
      azureAccess: hasAzureAccess(portalUser),
      readDeviceAccess: hasDeviceAccess(portalUser),
      updateDeviceAccess: hasDeviceUpdateAccess(portalUser),
      setDesiredAccess: hasSetDesiredAccess(portalUser),
      softwareUploadAccess: hasSoftwareUploadAccess(portalUser),
      softwareAccess: hasSoftwareReadAccess(portalUser),
      rolloutAccess: hasRolloutReadAccess(portalUser),
      createRolloutAccess: hasRolloutCreateAccess(portalUser),
      startRolloutAccess: hasRolloutStartAccess(portalUser),
      assignSoftwareAccess: hasAssignSoftwareAccess(portalUser),
      readLwm2mLogsAccess: hasLwm2mLogsAccess(portalUser),
      husqiotBusAccess: hasHusqiotBusAccess(portalUser),
      adminAccess: hasAdminAccess(portalUser),
      groups: [],
    };
  }, [session]);
};
